import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-a2d3e632"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "master-brand-warp"
};
const _hoisted_2 = {
  class: "left"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "brand-name"
};
const _hoisted_5 = {
  class: "brand-remark"
};
const _hoisted_6 = {
  class: "right"
};
const _hoisted_7 = {
  key: 0,
  class: "sub-item-list"
};
const _hoisted_8 = {
  class: "tips"
};
import SubBrandCard from '../SubBrandCard/index.vue';
import NoData from '@/components/NoData/index.vue';
import MyLoadingImage from '@/components/MyLoadingImage/index.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    infoItem: {
      type: Object,
      default: null
    }
  },
  emits: ['handleCommand', 'itemClick', 'createSubBtnClick', 'onEditMasterBtnClick', 'onDeleteMasterBtnClick', 'onModuleItemClick', 'createCopySubBtnClick', 'onDisassociateClick', 'showCreateSubBrandDialog'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const masterStatusObj = reactive({
      // 停运
      0: {
        src: require('@/assets/imgs/point_gray.png'),
        bgColor: '#CCD9DC'
      },
      // 运行
      1: {
        src: require('@/assets/imgs/point_green.png'),
        bgColor: '#CCD9DC'
      },
      // 终端审核
      2: {
        src: require('@/assets/imgs/point_orange.png'),
        bgColor: '#CCD9DC'
      }
    });
    const showSubList = ref(true);

    const handleCommand = data => {
      emits('handleCommand', data);
    };

    const onEditMasterBtnClick = () => {
      emits('onEditMasterBtnClick', props.infoItem.id);
    };

    const onDeleteMasterBtnClick = () => {
      emits('onDeleteMasterBtnClick', props.infoItem);
    };

    const onCreateSubBtnClick = type => {
      if (type === 'subBrand') {
        //新增子品牌
        emits('createSubBtnClick', props.infoItem);
      } else {
        //新增关联子品牌
        emits('createCopySubBtnClick', props.infoItem);
      }
    };

    const showCreateSubBrandDialog = () => {
      emits('showCreateSubBrandDialog', props.infoItem);
    };

    const onModuleItemClick = item => {
      emits('onModuleItemClick', item);
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _directive_permission = _resolveDirective("permission");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "title-warp",
        style: _normalizeStyle(`background-color: ${__props.infoItem && masterStatusObj[__props.infoItem.status].bgColor}`)
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        class: "brand-status",
        src: __props.infoItem && masterStatusObj[__props.infoItem.status].src,
        alt: ""
      }, null, 8, _hoisted_3), _createVNode(MyLoadingImage, {
        isShowBg: false,
        class: "brand-logo",
        width: "60px",
        height: "60px",
        style: {
          "margin-right": "16px",
          "border-radius": "12px"
        },
        src: __props.infoItem && __props.infoItem.mainAgentLogo
      }, null, 8, ["src"]), _createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_4, _toDisplayString(__props.infoItem && __props.infoItem.name), 1)]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_5, _toDisplayString(__props.infoItem && __props.infoItem.remark), 1)])])]), _createElementVNode("div", _hoisted_6, [_withDirectives((_openBlock(), _createElementBlock("div", {
        class: "cms-op-btn cms-op-btn-main",
        onClick: onDeleteMasterBtnClick
      }, [_createTextVNode(_toDisplayString(_ctx.$t('删除')), 1)])), [[_directive_permission, 'OP_PO_DM']]), _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "cms-op-btn cms-op-btn-main",
        onClick: onEditMasterBtnClick
      }, [_createTextVNode(_toDisplayString(_ctx.$t('编辑')), 1)])), [[_directive_permission, 'OP_PO_EM']])])], 4), showSubList.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [!__props.infoItem.subAgents || !__props.infoItem.subAgents.length ? (_openBlock(), _createBlock(NoData, {
        key: 0
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('您还没有子品牌，点击 “创建” 按钮创建。')), 1), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          onClick: showCreateSubBrandDialog,
          class: "cms-op-btn cms-op-btn-main"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('创建子品牌_c')), 1)]),
          _: 1
        })), [[_directive_permission, 'OP_PO_SC']])]),
        _: 1
      })) : (_openBlock(), _createBlock(SubBrandCard, {
        key: 1,
        data: __props.infoItem.subAgents,
        onHandleAdd: onCreateSubBtnClick,
        onHandleCommand: _cache[0] || (_cache[0] = data => handleCommand({ ...data,
          mainBrandItem: __props.infoItem
        })),
        onModuleItemClick: onModuleItemClick,
        onShowCreateSubBrandDialog: showCreateSubBrandDialog
      }, null, 8, ["data"]))])) : _createCommentVNode("", true)]);
    };
  }

});